import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { FollowerProject, FollowerProjectForm, Page, Statistic, DateInterval, FollowerProjectStatusLog } from '../models';

@Injectable()
export class FollowerProjectService {

  followerProjectsUrl = environment.dns + 'api/follower-projects/';

  constructor(private http: HttpClient) { }

  getPaginate(page: number, size: number, search: string = ""): Observable<Page<FollowerProject>> {
    return this.http.get<Page<FollowerProject>>(this.followerProjectsUrl + 'paginate?page=' + page + '&size=' + size + "&search=" + search);
  }

  getOne(id: number): Observable<FollowerProject> {
    return this.http.get<FollowerProject>(this.followerProjectsUrl + id);
  }

  getStatusHistory(id: number): Observable<FollowerProjectStatusLog[]> {
    return this.http.get<FollowerProjectStatusLog[]>(this.followerProjectsUrl + id + '/status-history');
  }

  getStatistics(dateInterval: DateInterval): Observable<any[]> {
    return this.http.post<any[]>(this.followerProjectsUrl + 'statistics', dateInterval);
  }

  getListByPeriod(dateInterval: DateInterval): Observable<any[]> {
    return this.http.post<any[]>(this.followerProjectsUrl + 'periods', dateInterval);
  }

  add(followerProjectForm: FollowerProjectForm): Observable<FollowerProject> {
    return this.http.post<FollowerProject>(this.followerProjectsUrl, followerProjectForm);
  }

  update(followerProjectForm: FollowerProjectForm): Observable<FollowerProject> {
    return this.http.put<FollowerProject>(this.followerProjectsUrl, followerProjectForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.followerProjectsUrl + id);
  }

  getConversionRateByCommercial(dateInterval: DateInterval): Observable<any[]> {
    return this.http.post<any[]>(this.followerProjectsUrl + 'conversion-rate/commercials', dateInterval);
  }

  getConversionRateBySite(dateInterval: DateInterval): Observable<any[]> {
    return this.http.post<any[]>(this.followerProjectsUrl + 'conversion-rate/sites', dateInterval);
  }
}
